import React from "react";
import { ArrowRight, Star, Wrench } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-black"
    >
      {/* Background image with overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://customer-assets.emergentagent.com/job_neuss-auto-repair/artifacts/9zk6i7hd_grafik.png')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,rgba(224,179,61,0.18),transparent_60%)]" />
      <div className="absolute inset-0 grain" />

      {/* Side label */}
      <div className="hidden md:flex absolute left-6 top-1/2 -translate-y-1/2 -rotate-90 origin-left text-[10px] tracking-[0.5em] uppercase text-zinc-500">
        Est. Neuss · Meisterbetrieb
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-12 pt-40 md:pt-48 pb-24 md:pb-32">
        {/* Kicker */}
        <div
          data-testid="hero-kicker"
          className="inline-flex items-center gap-3 border border-zinc-700 bg-black/40 backdrop-blur px-3 py-1.5 text-[10px] tracking-[0.3em] uppercase text-zinc-200"
        >
          <span className="w-1.5 h-1.5 gold-bg animate-pulse" />
          Kfz-Meisterwerkstatt · 41462 Neuss
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-headline"
          className="font-display mt-8 text-white text-[44px] sm:text-6xl md:text-7xl lg:text-[104px] leading-[0.95] uppercase tracking-tighter"
        >
          Ehrliche
          <br />
          <span className="gold-text">Werkstatt.</span>
          <br />
          Stil inklusive.
        </h1>

        <div className="mt-8 max-w-xl text-zinc-300 text-base md:text-lg leading-relaxed">
          Seit Generationen kümmern wir uns um die Autos unserer Nachbarn in
          Neuss — vom Alltagsbegleiter bis zum besonderen Wagen. Transparent,
          persönlich, zum fairen Preis.
        </div>

        {/* Actions */}
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <a
            href="#termin"
            data-testid="hero-appointment-btn"
            className="group inline-flex items-center justify-center gap-3 gold-bg text-black font-semibold px-7 py-4 text-sm tracking-[0.25em] uppercase transition-colors"
          >
            Termin anfragen
            <ArrowRight
              size={18}
              className="transition-transform group-hover:translate-x-1"
            />
          </a>
          <a
            href="#leistungen"
            data-testid="hero-services-btn"
            className="inline-flex items-center justify-center gap-3 border border-zinc-700 hover:border-[#E0B33D] hover:gold-text text-white px-7 py-4 text-sm tracking-[0.25em] uppercase transition-colors"
          >
            Leistungen ansehen
          </a>
        </div>

        {/* Stats strip */}
        <div className="mt-16 md:mt-24 grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800 max-w-4xl">
          {[
            { k: "4,7 / 5", v: "Google Rating", icon: Star },
            { k: "119+", v: "Rezensionen", icon: Star },
            { k: "Meister", v: "Zertifiziert", icon: Wrench },
            { k: "TÜV / HU", v: "vor Ort", icon: Wrench },
          ].map((s, i) => (
            <div
              key={i}
              className="bg-[#09090b] p-5 md:p-6"
              data-testid={`hero-stat-${i}`}
            >
              <s.icon size={16} className="gold-text" />
              <div className="mt-3 font-display text-2xl md:text-3xl uppercase">
                {s.k}
              </div>
              <div className="text-[11px] tracking-[0.25em] uppercase text-zinc-400 mt-1">
                {s.v}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom yellow bar */}
      <div className="absolute bottom-0 left-0 right-0 h-1 gold-bg" />
    </section>
  );
}
